module.exports = __webpack_public_path__ + "img/sigfox.4a178a0b.png";